// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Text } from 'gestalt';

type FollowersCountTextProps = {|
  followText: string,
  followerCount: number,
  userFollowed: ?boolean,
|};

const FollowersCountText = ({ followText, followerCount, userFollowed }: FollowersCountTextProps) =>
  interpolateNamedTemplate(i18n._('{{ followCount }} {{ followText }}'), {
    followCount: (
      <Box
        data-test-id="followCount"
        paddingX={1}
        key="followCount"
        {...(!userFollowed ? { dangerouslySetInlineStyle: { __style: { opacity: 0.75 } } } : {})}
      >
        <Text color={userFollowed ? 'gray' : 'white'} size="lg">
          <PrettyNumber value={followerCount} shortform shortformMaximumFractionDigits={0} />
        </Text>
      </Box>
    ),
    followText: (
      <Box data-test-id="followText" paddingX={1} key="followText">
        <Text bold color={userFollowed ? 'darkGray' : 'white'} size="lg">
          {followText}
        </Text>
      </Box>
    ),
  });

export default FollowersCountText;
